import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import './FAQ.scss';
import FAQItem from './FAQItem';
import { IQuestionAnswer } from '../../types/content';
import Fade from 'react-reveal/Fade';
import { adobeTrack } from '../../utils';
import { ViewAllFAQButtonContainer } from '../UI/Buttons/FAQButton/ViewAllFAQButtonContainer';

interface IFAQProps {
  context?: IContent;
}

const FAQ = ({ context }: IFAQProps) => {
  return (
    <section className="ubisoft-plus_faq">
      <Fade center cascade fraction={0.15}>
        <div className="ubisoft-plus_container">
          <h1 className="dark">{context.faq.title}</h1>
          <div className="accordion_section">
            {context.faq.QuestionAnswer.map(
              (qa: IQuestionAnswer, index: number) => {
                if (qa.question !== '' && qa.answer !== '') {
                  return (
                    <FAQItem key={'qa_' + index} item={qa}  />
                  );
                }
              })
            }
          </div>
          <ViewAllFAQButtonContainer content={context.faq.seeFaqButton} redirect={context.faq.cta.redirection} />
        </div>
      </Fade>
    </section>
  );
};

export default withContent(FAQ);
